export default {
    data() {
        return {
            ToastTabSuccess: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'success',
                className: 'custom-success-class'
            }, // Customized options for success toast
            ToastTabError: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'error'
            }
        }
    }
}